<template>
 <a v-if="thumbnail" :href="cloudappLink" target="_blank" class="unfurled_link">
    <div v-if="title" class="unfurled_heading">
      <span class="unfurled_title">
        {{ title }}
      </span>
      <br>
      <span v-if="provider" class="unfurled_provider">
        {{ provider }}
      </span>
    </div>
    <div class="unfurled_img_container">
      <img class="unfurled_img" :src="thumbnail"/>
    </div>
  </a>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    link: String
  },
  data() {
    return {
      title: "",
      provider: "",
      thumbnail: "",
      cloudappLink: this.link
    }
  },
  mounted: async function() {
    if (this.cloudappLink) {
      let cloudappLink = this.cloudappLink;
      try{
        let result = await axios.get(gon.oembed_service, {
          params: {
            url: cloudappLink,
            format: "json"
          }
        })
        if (result && result.status == 200 && result.data) {
          this.thumbnail = result.data.thumbnail_url || result.data.url;
          this.title = result.data.title;
          this.provider = result.data.provider_name;
        }
      } catch (error) {
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "application.scss";

.unfurled_link {
  display: block;
  padding: 0.5rem;

  .unfurled_heading {
    background: $mystic;
    border-radius: 4px 4px 0px 0px;
    padding: 0.5rem;
    color: black;
    font-size: 0.8rem;

    .unfurled_title {
      font-weight: bold;
    }

    .unfurled_provider {
      font-size: 0.7rem;
    }
  }

  .unfurled_img_container {
    text-align: center;
    background: $mystic;

      .unfurled_img {
      height: 9.4rem;
    }
  }
}
</style>
